export default function Loader() {
  return (
    <div className="h-screen w-screen absolute top-0 left-0 flex justify-center items-center bg-gray-lightest ">
      <h1>Loading...</h1>
    </div>
  );
}
